import React, { useState, useEffect, useRef } from "react";
import editIcon from "assets/themeIcons/edit-icon.svg";
import { useAppServices } from "hook/services";
import toast from "react-hot-toast";
import { uploadImageToGhl } from "hook/services";
import Quill from "quill";
import "quill/dist/quill.snow.css";

const Events = ({ data, onLoad, agency }) => {
  const currentItems = data || [];
  const AppService = useAppServices();

  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imageUploading, setImageUploading] = useState(false);

  const quillRef = useRef(null);
  const quillInstance = useRef(null);

  const handleOpenModal = (event) => {
    setSelectedEvent(event);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedEvent(null);
    setIsModalOpen(false);
  };

  const handleSave = async () => {
    try {
      setLoading(true);

      const descriptionHTML = quillInstance.current.root.innerHTML;

      const payload = {
        _id: selectedEvent?._id,
        event_name: selectedEvent?.event_name,
        event_description: descriptionHTML,
        image: selectedEvent?.image || "",
      };

      await AppService.events.Update({ payload });

      toast.success("Event updated successfully!");
      handleCloseModal();
      onLoad();
    } catch (err) {
      toast.error("Error updating event");
    } finally {
      setLoading(false);
    }
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImageUploading(true);
    try {
      const imageResponse = await uploadImageToGhl(file, agency);
      if (imageResponse?.data) {
        setSelectedEvent({
          ...selectedEvent,
          image: imageResponse.data,
        });
        toast.success("Image uploaded successfully!");
      }
    } catch (err) {
      toast.error("Failed to upload image");
    } finally {
      setImageUploading(false);
    }
  };

  useEffect(() => {
    if (isModalOpen) {
      setTimeout(() => {
        if (quillRef.current && !quillInstance.current) {
          quillInstance.current = new Quill(quillRef.current, {
            theme: "snow",
            placeholder: "Write event description...",
          });
        }
        if (selectedEvent && quillInstance.current) {
          quillInstance.current.root.innerHTML =
            selectedEvent.event_description || "";
        }
      }, 100);
    }

    return () => {
      if (!isModalOpen && quillInstance.current) {
        quillInstance.current = null;
      }
    };
  }, [isModalOpen]);

  const tableTHStyles = {
    fontFamily: "Poppins",
    fontWeight: 600,
  };

  return (
    <>
      <div style={{ width: "100%", overflowX: "auto" }}>
        <table
          className="table"
          style={{
            width: "100%",
            borderCollapse: "collapse",
            minWidth: "1200px",
          }}
        >
          <thead>
            <tr style={{ background: "#F7F7F7", borderRadius: "18px" }}>
              <th className="p-20-px" style={tableTHStyles}>
                Image
              </th>

              <th className="p-20-px" style={tableTHStyles}>
                Title
              </th>
              <th className="p-20-px" style={tableTHStyles}>
                Business
              </th>
              <th className="p-20-px" style={tableTHStyles}>
                Description
              </th>
              <th className="p-20-px" style={tableTHStyles}>
                Date
              </th>
              <th className="p-20-px" style={tableTHStyles}>
                Edit
              </th>
            </tr>
          </thead>

          <tbody>
            {currentItems.length > 0 ? (
              currentItems.map((item, index) => (
                <tr key={index}>
                  <td className="p-20-px">
                    {item?.image ? (
                      <img
                        src={item.image}
                        alt="blog"
                        style={{ width: 60, height: 60, borderRadius: 6, objectFit: "cover" }}
                      />
                    ) : (
                      "-"
                    )}
                  </td>
                  <td className="p-20-px">{item?.event_name}</td>

                  <td className="p-20-px">{item?.account_id?.first_name}</td>

                  <td className="p-20-px">
                    <div dangerouslySetInnerHTML={{ __html: item?.event_description }} />
                  </td>
                  <td className="p-20-px">
                    {new Date(item?.createdAt).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </td>

                  <td className="p-20-px">
                    <img
                      onClick={() => handleOpenModal(item)}
                      width={20}
                      src={editIcon}
                      style={{ cursor: "pointer" }}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} className="text-center">
                  No events found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {isModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "10px",
              padding: "30px",
              width: "600px",
              maxWidth: "90%",
              boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
            }}
          >
            <h3>Edit Event</h3>

            <label style={labelStyle}>Title</label>
            <input
              type="text"
              value={selectedEvent?.event_name || ""}
              onChange={(e) =>
                setSelectedEvent({
                  ...selectedEvent,
                  event_name: e.target.value,
                })
              }
              style={inputStyle}
            />

            <label style={labelStyle}>Description</label>
            <div
              ref={quillRef}
              style={{
                height: "200px",
                border: "1px solid #ccc",
                borderRadius: "8px",
                marginTop: "10px",
              }}
            ></div>

            <label style={labelStyle}>Image</label>
            <input type="file" accept="image/*" onChange={handleImageUpload} />

            <div style={buttonRow}>
              <button onClick={handleCloseModal} style={cancelBtn}>
                Cancel
              </button>

              <button
                onClick={handleSave}
                disabled={loading || imageUploading}
                style={saveBtn}
              >
                {loading || imageUploading ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// Styles
const inputStyle = {
  width: "100%",
  padding: "10px",
  marginTop: "8px",
  borderRadius: "8px",
  border: "1px solid #ddd",
};
const labelStyle = { fontWeight: 600, marginTop: "20px", display: "block" };
const buttonRow = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "10px",
  marginTop: "25px",
};
const cancelBtn = {
  padding: "8px 16px",
  background: "#ccc",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
};
const saveBtn = {
  padding: "8px 16px",
  background: "#007bff",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
};

export default Events;
